const hostname = window.location.hostname;
export const FILE_UPLOAD_API =
  hostname === "dev.dopriorauth.com" || hostname === "go.dopriorauth.com"
    ? "https://7bki8v4838.execute-api.us-east-1.amazonaws.com/api/"
    : "https://clfyci50cg.execute-api.us-east-1.amazonaws.com/dev/";
